'use client';

import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';
import { Card } from '@/ui/primatives';

export const UserCard = styled(Card)`
  display: flex;
  /* align-items: center; */
  gap: 10px;
  padding: 10px;
  background: ${colors.secondary.lightGray1};
`;
